import './RadioButton.scss';
import React, { FC } from 'react';
// import { Form } from 'react-bootstrap';

interface IRadioButtonProps {
	checked?: boolean;
	id?: string;
	label?: string;
	onChange?: React.ChangeEventHandler;
}

const RadioButton: FC<IRadioButtonProps> = ({ checked, id, label, onChange }) => {
	return (
		// <Form.Check
		// 	required
		// 	type={'radio'}
		// 	id={`${id}`}
		// 	label={label}
		// 	checked={checked}
		// 	onChange={onChange}
		// 	value={'Blue'}
		// />
		<div className="flex items-center gap-2">
      <input
        type="radio"
        id={id}
        checked={checked}
        onChange={onChange}
        value="Blue"
        className="w-4 h-4 text-primary border-primary-text focus:ring-primary cursor-pointer"
      />
      {label && (
        <label htmlFor={id} className="text-caption text-primary-text cursor-pointer select-none">
          {label}
        </label>
      )}
    </div>
	);
};

export default RadioButton;
